import { reactive } from 'vue';
import { footnoteDispatchers, footnotesStore, initialState } from './local-footnotes.connection';
import { connectionName, LocalFootnoteStoreState } from './local-footnotes.types';

const localFootnotes = reactive<LocalFootnoteStoreState>(initialState());

function subscribe() {
  footnotesStore.subscribe(connectionName, (state: LocalFootnoteStoreState) => {
    Object.assign(localFootnotes, state);
  });
}

if (footnotesStore) {
  subscribe();
} else {
  // Storybook Workaround
  const init = setInterval(() => {
    if (footnotesStore) {
      subscribe();
      clearInterval(init);
    }
  }, 200);
}

export const useLocalFootnotesStore = () => ({
  state: localFootnotes,
  dispatchers: footnoteDispatchers,
});
